import React from "react";
import { cn } from "../../lib/utils/utils";

export function FieldGroup({ className, ...props }) {
  return <div className={cn("space-y-4", className)} {...props} />;
}

export function FieldSet({ className, ...props }) {
  return <fieldset className={cn("space-y-4", className)} {...props} />;
}

export function Field({ className, ...props }) {
  return <div className={cn("space-y-1.5", className)} {...props} />;
}

export function FieldLabel({ className, ...props }) {
  return <label className={cn("text-sm font-semibold text-panel-ink", className)} {...props} />;
}

export function FieldError({ className, ...props }) {
  return <p className={cn("text-xs text-red-600", className)} {...props} />;
}
